

uniform vec3 u_color;
uniform float u_progress;
float remap(float value, float originMin, float originMax, float destinationMin, float destinationMax)
{
    return destinationMin + (value - originMin) * (destinationMax - destinationMin) / (originMax - originMin);
}
void main() {
    // Coordonnées centrées autour de (0,0)
    vec2 coord = gl_PointCoord - vec2(0.5);
    float dist = length(coord);

    // Cercle doux (avec smoothstep pour lisser les bords)
        float expodingProgress = remap(u_progress, 0.0, 0.5, 0.0, 1.0);
    expodingProgress = clamp(expodingProgress, 0.0, 1.0);
    expodingProgress = 1.0-pow(1.0-expodingProgress, 3.0);
    float alpha = 1.0 - smoothstep(0.45, 0.5, dist);
float finalAlpha = clamp(alpha - expodingProgress, 0.0, 1.0);

    // Appliquer la couleur et alpha
    gl_FragColor = vec4(u_color*10., finalAlpha);

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}
